import { useDispatch, useSelector } from "react-redux";

import { MAP_STYLES } from "@/constants/map";
import { useMap } from "@/hooks/map/core/useMapContext";
import { RootState } from "@/store";
import { setMapStyle } from "@/store/slice/mapSlice";
import { transformStyle } from "@/utils/map";

import BaseMapControl, {
  type BaseMapStyleKey
} from "../controls/BaseMapControl";

/**
 * Redux/`MapProvider` adapter around the generic `BaseMapControl` — it owns
 * where the selection lives and how the shared map applies it.
 */
export default function BaseMapMenu() {
  const dispatch = useDispatch();
  const { baseMapRef, map } = useMap();
  const { baseMap } = useSelector((state: RootState) => state.map);

  const handleClickBaseMap = (key: BaseMapStyleKey) => {
    dispatch(setMapStyle(key));

    const nextStyle = MAP_STYLES[key];

    if (nextStyle == null) return;
    if (JSON.stringify(baseMapRef.current) === JSON.stringify(nextStyle))
      return;

    map?.setStyle(nextStyle.value, {
      diff: true,
      transformStyle
    });

    baseMapRef.current = nextStyle.value;
  };

  return (
    <BaseMapControl
      styles={MAP_STYLES}
      selected={baseMap}
      onSelect={handleClickBaseMap}
    />
  );
}
